import React, { useEffect, useState } from 'react'
import Api from "../api/api";
import { toast } from 'react-toastify';

export default function Contact() {

const [ value , setValue] = useState({
  user_name : '' ,
  email : '' ,
  mobile: '' ,
  message:''
})

async function getProfile() {
    try {
      let res = await Api.profile();
      setValue(res?.data[0]);
    } catch (error) {
      alert("Error while Get Profile");
    }
  }
 useEffect(()=>{
  getProfile()
 },[])

 async function handleSubmit(e) {
  e.preventDefault()
 if(value.message){
  try {
    let res = await Api.contactUs(value);
    console.log(res);
    
    toast.success(res.message)
    setValue({ ...value, message:""});
  } catch (error) {
    console.log(error);
  } }
  else{
    toast.error("Please Enter Message")
  }
}
   
const handleChange = (e) => {
  setValue({ ...value, [e.target.name]: e.target.value });
};


  return (
    <div className='contact'>
      <div className="contact-wrap bg-white">
        <h3 className='text-center'>Contact Us</h3>
        <form action="" onSubmit={handleSubmit}>
          <div className="form-box">
            <label htmlFor="#" className="form-label">Name</label>
            <input type="text" placeholder='Type here' className="form-control" required  value={value.user_name} disabled />
          </div>
          <div className="form-box">
            <label htmlFor="Email" className="form-label">Email</label>
            <input type="email" placeholder='Email' className="form-control" required value={value.email} disabled />
          </div>
          {/*<div className="form-box">
            <label htmlFor="mobileNumber" className="form-label">mobile Number</label>
            <input type="number" placeholder='Number' className="form-control" required value={value.mobile} disabled />
          </div>*/}
          <div className="form-box">
            <label htmlFor="#" className="form-label">Your message</label>
            <textarea  className='form-control' name="message" placeholder='Type here'  id="" value={value.message} onChange={(e)=>{handleChange(e)}} ></textarea>
          </div>
          <div className="w-100 text-center">
            <button type='submit' className='btn text-center bg-primary'>Contact Us</button>
          </div>
        </form>
      </div>
    </div>
  )
}
